+<template>
  <div>
    <Suggestions
      :suggestions="suggestions"
      :colors="colors"
      @sendSuggestion="_submitSuggestion"
    />
    <div
      v-if="file"
      class="file-container"
      :style="{
        backgroundColor: colors.userInput.text,
        color: colors.userInput.bg,
      }"
    >
      <span class="icon-file-message">
        <img
          src="./assets/file.png"
          alt="genericFileIcon"
          height="15"
        >
      </span>
      {{ file.name }}
      <span
        class="delete-file-message"
        @click="cancelFile()"
      >
        <img
          src="./assets/close.png"
          alt="close icon"
          height="10"
          title="Remove the file"
        >
      </span>
    </div>
    <form
      class="sc-user-input"
      :class="{ info: showInformation, active: inputActive }"
      :style="'background:' + colors.userInput.bg + ';--showInput:' + showInput"
    >
      <div
        ref="userInput"
        role="button"
        tabindex="0"
        contenteditable="true"
        :placeholder="placeholder"
        class="sc-user-input--text"
        :style="{ color: colors.userInput.text, cursor: 'text' }"
        @focus="setInputActive(true)"
        @blur="setInputActive(false)"
        @keydown="handleKeyDown"
        @paste="onPaste"
      >
        <!--v-tooltip.top-center="msgClarity"-->
      </div>
      <div class="sc-user-input--buttons">
        <div
          v-if="showEmoji"
          class="sc-user-input--button"
        >
          <EmojiIcon
            :on-emoji-picked="_handleEmojiPicked"
            :color="colors.userInput.text"
          />
        </div>
        <div
          v-if="showFile"
          class="sc-user-input--button"
        >
          <FileIcons
            :on-change="_handleFileSubmit"
            :color="colors.userInput.text"
          />
        </div>
        <!-- Tooltip sobre boton¿
        <v-popover offset="16" :open="disabled">
          <template slot="popover">
            <p style="margin:0">{{ msgLength }}</p>
          </template>

          <div class="sc-user-input--button">
            <SendIcon :onClick="_submitText" :color="colors.userInput.text" />
          </div>
        </v-popover>
        Fin Tooltip-->
        <!-- boton para utilizar microfono -->
        <div
          v-show="onMicro"
          class="sc-microphone-input--button"
        >
          <MicrophoneIcon
            :on-click="_activateMicro"
            :color="colors.userInput.text"
          />
        </div>
        <!-- boton para parar la funcion del microfono -->
        <div
          v-show="stopMicro"
          class="sc-stop-input--button"
        >
          <StopIcon
            :on-click="_stopMicro"
            :color="colors.userInput.text"
          />
        </div>
        <div
          v-show="send"
          class="sc-user-input--button"
        >
          <SendIcon
            :on-click="_submitText"
            :color="colors.userInput.text"
          />
        </div>
      </div>
    </form>
    <div
      v-if="showInformation"
      class="contenido-desarrolloGB"
    >
      <!--contenido-->
      <div class="texto-desarrolloGB">
        Desarrollado por
      </div>
      <div class="empresa-desarrolloGB">
        <a
          href="https://gatblac.com/productos/lara-chatbots"
          target="_blank"
        >Gatblac</a>
      </div>
      <div
        v-if="showAIGenerativeInfo"
        class="contenido-desarrolloGBxAI"
      >
        <div class="texto-desarrolloGBxAI">
          con tecnología
        </div>
        <div class="empresa-desarrolloGB">
          <a>ChatGPT</a>
        </div>
      </div>
    </div>
    <!--cierre contenido-->
  </div>
</template>

<script>
import { serverUI } from './main'
import EmojiIcon from './EmojiIcon.vue'
import FileIcons from './FileIcons.vue'
import SendIcon from './SendIcon.vue'
import Suggestions from './Suggestions.vue'
import MicrophoneIcon from './MicrophoneIcon.vue'
import StopIcon from './StopIcon.vue'

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
let recognition
if (SpeechRecognition) {
  recognition = new SpeechRecognition()
  recognition.continuous = true
  recognition.lang = 'es-ES'
  recognition.interimResults = false // Debería ser `interimResults` en lugar de `interimResult`
// const microStatus = window.protocol.channel.plugin_enable_microphone
}

export default {
  components: {
    EmojiIcon,
    FileIcons,
    SendIcon,
    Suggestions,
    MicrophoneIcon,
    StopIcon
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: () => false
    },
    suggestions: {
      type: Array,
      default: () => []
    },
    showFile: {
      type: Boolean,
      default: () => false
    },
    onSubmit: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    pluginEnabledMicrophone: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Object,
      required: true
    },
    showInput: {
      type: String,
      default: ''
    },
    lastUserText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      msgLength: 'Tu mensaje debe tener al menos dos caracteres.',
      msgClarity:
        'Recuerda expresar tu pregunta de la manera más clara posible.',
      disabled: false,
      file: null,
      inputActive: false,
      showInformation: window.protocol.view.enabled_info,
      showAIGenerativeInfo: window.protocol.view.ai_generative_enabled,
      textInput: '',
      recognition: null,
      transcript: '',
      onMicro: false, // mantiene oculto el icono micro.
      stopMicro: false, // Mantiene oculto el icono pausar micro.
      send: false // mantiene oculto el icono de enviar
    }
  },
  mounted () {
    const microStatus = this.pluginEnabledMicrophone
    this.showButton(microStatus)
    if (this.lastUserText) this.$refs.userInput.innerHTML = this.lastUserText
  },
  beforeDestroy () {
    this.textInput = this.$refs.userInput.innerHTML
    serverUI.$emit('setLastUserText', this.textInput)
  },
  methods: {
    showButton (microStatus) {
      if (microStatus === true && recognition) {
        this.onMicro = true
      } else {
        this.onMicro = false
        this.send = true
      }
    },
    cancelFile () {
      this.file = null
    },
    setInputActive (onoff) {
      this.inputActive = onoff
    },
    handleKeyDown (event) {
      if (
        this.$refs.userInput.innerHTML.length > 150 &&
        event.keyCode !== 8 &&
        event.keyCode !== 13
      ) {
        event.preventDefault()
        return
      }
      if (event.keyCode === 13 && !event.shiftKey) {
        this._submitText(event)
        if (this.microStatus === false) {
          this.onMicro = false
          this.stopMicro = false
          recognition.stop()
        }
        serverUI.$emit('setLastUserText', '')
        event.preventDefault()
      }
    },
    onPaste (event) {
      event.preventDefault()
      const text = event.clipboardData
        .getData('text/plain')
        .replace(/\n/g, '')
        .replace(/\r/g, '')
      if (text.length > 150) {
        return
      }
      this.$refs.userInput.innerHTML = this.$refs.userInput.innerHTML + text
    },
    _submitSuggestion (suggestion) {
      this.onSubmit({ author: 'me', type: 'text', data: { text: suggestion } })
    },
    // funcion para activar el microfono y transcribir la voz en texto
    _activateMicro () {
      this.onMicro = false // oculta icono de micro.
      this.stopMicro = true // hace visible el icono de parar
      recognition.start()
      recognition.onresult = (event) => {
        const texto = event.results[event.results.length - 1][0].transcript
        this.$refs.userInput.textContent += texto
        this.onMicro = false
        this.stopMicro = true
      }
    },
    // funcion que permite detener el microfono y al momento de hacerlo se envia la info
    _stopMicro () {
      recognition.stop()
      this.onMicro = true
      this.stopMicro = false
      this._submitText()
    },
    _submitText () {
      const text = this.$refs.userInput.textContent
      const file = this.file
      if (file) {
        if (text && text.length > 0) {
          this.onSubmit({
            author: 'me',
            type: 'file',
            data: { text, file }
          })
          this.file = null
          this.$refs.userInput.innerHTML = ''
        } else {
          this.onSubmit({
            author: 'me',
            type: 'file',
            data: { file }
          })
          this.file = null
        }
      } else {
        if (text && text.length > 1) {
          this.onSubmit({
            author: 'me',
            type: 'text',
            data: { text }
          })
          this.$refs.userInput.innerHTML = ''
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
    },
    _handleEmojiPicked (emoji) {
      this.onSubmit({
        author: 'me',
        type: 'emoji',
        data: { emoji }
      })
    },
    _handleFileSubmit (file) {
      this.file = file
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-user-input {
    min-height: 55px;
    margin: 0px;
    position: relative;
    bottom: 0;
    pointer-events: var(--showInput);
    display: flex;
    background-color: #f4f7f9;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
    cursor: text;
}

.sc-user-input.info {
    min-height: 55px;
    margin: 0px;
    position: relative;
    bottom: 0;
    pointer-events: var(--showInput);
    display: flex;
    background-color: #f4f7f9;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
    cursor: text;
}

.sc-user-input--text {
    width: 80%;
    resize: none;
    border: none;
    outline: none;
    border-bottom-left-radius: 10px;
    box-sizing: border-box;
    padding: 18px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.33;
    white-space: pre-wrap;
    word-wrap: break-word;
    color: #565867;
    -webkit-font-smoothing: antialiased;
    max-height: 200px;
    overflow: scroll;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    cursor: text;
}

.sc-user-input--text:empty:before {
    content: attr(placeholder);
    display: block;
    filter: contrast(15%);
    outline: none;
}

.sc-user-input--buttons {
    position: absolute;
    right: 10px;
    height: 100%;
    display: flex;
}

.sc-user-input--button:first-of-type {
    width: 40px;
}

.sc-user-input--button {
    width: 30px;
    height: 55px;
    margin-left: 2px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.sc-user-input.active {
    box-shadow: none;
    background-color: white;
    box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);
}

.sc-user-input--button label {
    position: relative;
    height: 24px;
    padding-left: 3px;
    cursor: pointer;
}

.sc-user-input--button label:hover path {
    fill: rgba(86, 88, 103, 1);
}

.sc-user-input--button input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99999;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    overflow: hidden;
}

//Styles asociados al uso de voz y micrófono
.sc-microphone-input--buttons {
    position: absolute;
    right: 10px;
    height: 100%;
    display: flex;
}

.sc-microphone-input--button:first-of-type {
    width: 40px;
}

.sc-microphone-input--button {
    width: 30px;
    height: 55px;
    margin-left: 2px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.sc-microphone-input.active {
    box-shadow: none;
    background-color: white;
    box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);
}

.sc-microphone-input--button label {
    position: relative;
    height: 24px;
    padding-left: 3px;
    cursor: pointer;
}

.sc-microphone-input--button label:hover path {
    fill: rgba(86, 88, 103, 1);
}

.sc-microphone-input--button input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99999;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    overflow: hidden;
}
.sc-stop-input--buttons {
    position: absolute;
    right: 10px;
    height: 100%;
    display: flex;
}

.sc-stop-input--button:first-of-type {
    width: 40px;
}

.sc-stop-input--button {
    width: 30px;
    height: 55px;
    margin-left: 2px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.sc-stop-input.active {
    box-shadow: none;
    background-color: white;
    box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);
}

.sc-stop-input--button label {
    position: relative;
    height: 24px;
    padding-left: 3px;
    cursor: pointer;
}

.sc-stop-input--button label:hover path {
    fill: rgba(86, 88, 103, 1);
}

.sc-stop-input--button input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99999;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    overflow: hidden;
}
//End Styles asociados al uso de voz y micrófono
.tooltip-gb {
  display: block !important;
  z-index: 999999999999;
  margin-top: 0 !important;
  margin-left: -40px !important;
  background-color: transparent !important;
  border: none !important;
  .tooltip-gb-inner {
    background: #acafbf;
    color: white;
    border-radius: 16px;
    padding: 7px;
    /*font-family: "OpenSansRegular", sans-serif, Arial !important;*/
    font-size: 10px;
    max-width: 250px;
    line-height: 12px;
    overflow-wrap: break-word;
  }
  .tooltip-gb-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 7px;
    border-color: #acafbf;
    z-index: 1;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-gb-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-gb-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-gb-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-gb-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
  &.popover {
    .popover-inner {
      background: #4067aa;
      color: #fff;
      border-radius: 16px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
      padding: 8px 10px;
      font-size: 10px;
      max-width: 250px;
      line-height: 12px;
      overflow-wrap: break-word;
    }
    .popover-arrow {
      border-color: #4067aa;
    }
    .popover {
      background-color: transparent;
      border: none;
    }
  }
}

.contenido-desarrolloGB {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    font-weight: bold;
    padding: 5px;
    color: #99a4b0;
    font-size: 10px;
    margin: auto;
}

.texto-desarrolloGB {
    margin-right: 4px;
}

.empresa-desarrolloGB a {
    text-decoration: none;
    background-color: transparent;
}
.contenido-desarrolloGBxAI{
  display: flex !important;
}
.texto-desarrolloGBxAI{
    margin-right: 4px;
    margin-left: 4px;
}
</style>
